import React, { Component } from 'react'
import {
  Container,
  Grid,
  Header,
  Image,
  Loader,
} from 'semantic-ui-react'
import {connect} from 'react-redux';

import {
    submitResetPassword,
    getPublicKey,
} from '../../actions';
import FormsResetPassword from '../../component/forms/reset_password/forms_reset_password';
import { stat } from 'fs';

class ResetPasswordPage extends Component {
    componentDidMount() {
        this.props.getPublicKey();
        if (this.props.userData) {
          this.props.history.push('/app');
        }
    }
    render() {
        if (!this.props.publicKey) { return <Loader active />; }
        return (
            <Container style={{ paddingTop: '2.5em' }}>

                <Image src="/groupcare_logo_hor.jpg" size="medium"/>

                <Header as='h2' block>
                    Reset Password
                </Header>

                <Grid centered columns={1}>
                    <Grid.Column>
                        <FormsResetPassword
                            submitResetPassword={this.props.submitResetPassword}
                            tokenId={this.props.match.params.tokenId}
                        />
                    </Grid.Column>
                </Grid>
            </Container>
        );
    }
}

function mapStateToProps(state) {
    return {
        userData: state.user.user,
        publicKey: state.appConfig.publicKey
    };
  }

export default connect(mapStateToProps, {
    submitResetPassword,
    getPublicKey,
})(ResetPasswordPage);
